module.exports = __webpack_public_path__ + "img/ico-re-reply.97229a13.svg";